import { Component, OnInit, Input, Optional, Injector } from '@angular/core';
import { LoadDrupalLangService } from '../../../../../common-page-components/services/load-drupal-lang.service';
import { DrupalLangClass } from '../../../../../common-page-components/classes/drupal-lang-class';

@Component({
  selector: 'lib-athlete-name',
  templateUrl: './athlete-name.component.html',
  styleUrls: ['./athlete-name.component.scss']
})
export class AthleteNameComponent extends DrupalLangClass {
  @Input()
  fname: string;
  @Input()
  gname: string;
  @Input()
  wnameord: boolean;
  @Input()
  id: number | string;

  /**
   * A input property for set a custom color for the name
   *
   * @type {boolean}
   * @memberof AthleteNameComponent
   */
  @Input()
  color: string;

  /**
   *Creates an instance of AthleteNameComponent.
   * @param {LoadDrupalLangService} drupalLangService The drupal lang service for get the path in templates.
   * @memberof AthleteNameComponent
   */
  constructor(injector: Injector,
  ) {
    super(injector);

  }

}
